import { ReactNode, useState } from 'react'

import { Nullable } from '@types'

import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton, IconButtonProps, ListItemIcon, ListItemText, Menu, MenuItem, MenuProps } from '@mui/material'

export interface EllipsisMenuItem {
  label: string
  icon?: ReactNode
  onClick: (e: Nullable<React.MouseEvent<HTMLElement>>) => void
  disabled?: boolean
}

export interface EllipsisMenuProps {
  items: EllipsisMenuItem[]
  menuProps?: Omit<MenuProps, 'open' | 'anchorEl' | 'onClose'>
  iconButtonProps?: Partial<IconButtonProps>
}

export const EllipsisMenu = ({ items, menuProps, iconButtonProps }: EllipsisMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        aria-label="more options"
        aria-controls={open ? 'ellipsis-menu' : undefined}
        aria-haspopup="true"
        onClick={handleOpen}
        size="small"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...iconButtonProps}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="ellipsis-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...menuProps}
      >
        {items.map(({ label, icon, onClick, disabled }) => (
          <MenuItem
            key={label}
            onClick={e => {
              handleClose()
              onClick(e)
            }}
            disabled={disabled}
          >
            {icon && <ListItemIcon>{icon}</ListItemIcon>}
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
